const value = {
    pointsToNextLevel: 'Points to next level',
    pointsToCompletion: 'Points to completion',
    noAssignedUnits: "You don't have any assigned units",

    learnAndLevelUp: 'Learn and level up',
    allUnitsPassed: 'All units passed',
    toNextLevel: 'To next level:',
    toMax: 'To next level:',
    junior: 'Beginner',
    middle: 'Mid-level',
    senior: 'Champion',
  };

export default value;
